module.exports = __webpack_public_path__ + "static/media/ico-facebook.b3fcabb3.svg";